import React, { FC } from 'react';

interface IUserContactTableSubHeaderProps {
  title: string;
}

export const UserContactTableSubHeader: FC<IUserContactTableSubHeaderProps> = (props) => (
  <tr className="widget-table__header">
    <td colSpan={4} className="font-weight-semibold text-tiny">
      {props.title}
    </td>
  </tr>
);
